<template>
  <nav
    v-if="isProfileLoaded"
    class="clinic-panel__left-side-menu"
  >
    <div>
      <template
        v-for="{
          classes, name, styles, sub, to,
        } in navigateItemsWithoutBottomItems"
      >
        <button
          class="clinic-panel__left-side-menu__item"
          title="Открыть подменю"
          type="button"
          v-bind:class="classes"
          v-bind:key="name"
          v-if="sub"
          v-on:click="emmitSubMenu(name, sub)"
        >
          <span
            class="clinic-panel__left-side-menu__item__icon"
            v-bind:style="styles"
          />
          <span class="clinic-panel__left-side-menu__item__link">
            {{ name }}
          </span>
        </button>
        <router-link
          class="clinic-panel__left-side-menu__item"
          v-bind:class="classes"
          v-bind:key="name"
          v-bind:to="to"
          v-else
        >
          <span
            class="clinic-panel__left-side-menu__item__exclamation-mark-alert"
            title="Заполните все недостающие данные"
            v-if="isShowAlerts(name)">
            !
          </span>
          <span
            class="clinic-panel__left-side-menu__item__icon"
            v-bind:style="styles"
          />
          <span class="clinic-panel__left-side-menu__item__link">{{ name }}</span>
          <span
            class="clinic-panel__left-side-menu__item__appointment-counter"
            v-if="isShowCounters(name)">
            {{ getCount(name) }}
          </span>
        </router-link>
      </template>
      <button
        class="clinic-panel__left-side-menu__item"
        title="Открыть подменю"
        type="button"
        v-bind:class="settingsItem.classes"
        v-bind:key="settingsItem.name"
        v-if="settingsItem"
        v-on:click="emmitSubMenu(settingsItem.name, settingsItem.sub)"
      >
        <span
          class="clinic-panel__left-side-menu__item__icon"
          v-bind:style="settingsItem.styles"
        />
        <span
          class="clinic-panel__left-side-menu__item__exclamation-mark-alert"
          title="Заполните все недостающие данные"
          v-if="isShowAlerts(settingsItem.name)">
          !
        </span>
        <span class="clinic-panel__left-side-menu__item__link">
          {{ settingsItem.name }}
        </span>
      </button>
    </div>
    <button
      type="button"
      class="clinic-panel__left-side-menu__item"
      v-bind:class="helpItem.classes"
      v-bind:key="helpItem.name"
      v-on:click="onHelpButtonClick()"
    >
      <span
        class="clinic-panel__left-side-menu__item__icon"
        :class="{ 'help-item': helpItem }"
        v-bind:style="helpItem.styles"
      />
      <span class="clinic-panel__left-side-menu__item__link">{{ helpItem.name }}</span>
    </button>
  </nav>
</template>
<script>
import { GOAL_CLICK_HELP_BUTTON } from '@/plugins/metric';

export default {
  name: 'left-navbar',
  computed: {
    /**
     * @description Навигационные элементы без нижних элементов
     * @returns {*[]}
     */
    navigateItemsWithoutBottomItems() {
      return this.navigateItems.filter((item) => item.name !== 'Настройки' && item.name !== 'Помощь');
    },
    /**
     * @description Элемент с настройками
     * @returns {*}
     */
    settingsItem() {
      return this.navigateItems.find((item) => item.name === 'Настройки');
    },
    helpItem() {
      return this.navigateItems.find((item) => item.name === 'Помощь');
    },
  },
  methods: {
    emmitSubMenu(name, sub) {
      this.$emit('toggle-sub-menu', name, sub);
    },
    /**
     * @description Получить количество для индикатора
     * @param name
     */
    getCount(name) {
      const currentItem = this.counters.find((item) => (item.name === name));
      return currentItem.count;
    },
    /**
     * @description Обработать переход на страницу помощи.
     * @returns {void}
     */
    onHelpButtonClick() {
      window.open('https://mis-help.32top.kz/instructions', '_blank', 'noopener noreferrer');
      this.$goal(GOAL_CLICK_HELP_BUTTON);
    },
  },
  props: {
    counters: { type: Array, default: () => [] },
    alerts: { type: Array, default: () => [] },
    isProfileLoaded: { type: Boolean, default: () => false },
    isShowCounters: { type: Function, required: true },
    isShowAlerts: { type: Function, required: true },
    navigateItems: { type: Array, default: () => [] },
  },
};
</script>
<style lang="scss">
@media print {
  .clinic-panel__left-side-menu {
    display: none;
  }
  #jvlabelWrap {
    display: none;
  }
}
</style>
